"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSlate = void 0;
const domhandler_1 = require("domhandler");
const domutils_1 = require("domutils");
const html_entities_1 = require("html-entities");
const slate_1 = require("slate");
const default_1 = require("../config/default");
const domhandler_2 = require("./domhandler");
const _1 = require(".");
const _2 = require(".");
const convertSlate = ({ node, config = default_1.config, isLastNodeInDocument = false, customElementTransforms, 
/* tslint:disable:no-shadowed-variable */
transformText = (text) => text, 
/* tslint:disable:no-shadowed-variable */
transformElement = (element) => element, wrapChildren = (children) => new domhandler_1.Document(children), }) => {
    if (slate_1.Text.isText(node)) {
        const str = config.alwaysEncodeBreakingEntities && !config.encodeEntities ? (0, _1.encodeBreakingEntities)(node.text) : node.text;
        const strLines = config.convertLineBreakToBr ? str.split('\n') : [str];
        const textChildren = [];
        // convert line breaks to br tags
        strLines.forEach((line, index) => {
            const markElements = [];
            const markTransformKeys = (0, _2.intersection)(config.markTransforms || {}, node);
            markTransformKeys.forEach((key) => {
                var _a;
                if ((_a = config.markTransforms) === null || _a === void 0 ? void 0 : _a[key]) {
                    const markElement = config.markTransforms[key]({ node, attribs: {} });
                    if (markElement) {
                        markElements.push(markElement);
                    }
                }
            });
            Object.keys(config.markMap).forEach((key) => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (node[key]) {
                    const elements = config.markMap[key].map((tagName) => {
                        var _a;
                        if ((_a = config.markTransforms) === null || _a === void 0 ? void 0 : _a[tagName]) {
                            return config.markTransforms[tagName]({ node, attribs: {} });
                        }
                        return new domhandler_1.Element(tagName, {}, []);
                    }).filter((element) => element !== undefined);
                    markElements.push(...elements);
                }
            });
            // clone markElements (it gets modified)
            const markElementsClone = [...markElements];
            const textElement = (0, domhandler_2.nestedMarkElements)(markElements, new domhandler_1.Text(line));
            if (config.alwaysEncodeCodeEntities &&
                !config.encodeEntities &&
                (0, domhandler_1.isTag)(textElement) &&
                (0, domutils_1.getName)(textElement) === 'pre') {
                if (config.alwaysEncodeBreakingEntities) {
                    // revert the earlier encoding - encode will re-encode
                    line = (0, _1.decodeBreakingEntities)(line);
                }
                textChildren.push((0, domhandler_2.nestedMarkElements)(markElementsClone, new domhandler_1.Text((0, html_entities_1.encode)(line))));
            }
            else {
                textChildren.push(textElement);
            }
            if (index < strLines.length - 1) {
                textChildren.push(transformElement(new domhandler_1.Element('br', {})));
            }
        });
        return wrapChildren(textChildren.map((child) => transformText(child)));
    }
    const children = node.children
        ? node.children.map((n) => (0, exports.convertSlate)({
            node: n,
            config,
            customElementTransforms,
            transformText,
            transformElement,
            wrapChildren,
        }))
        : [];
    let attribs = {};
    if (config.elementAttributeTransform) {
        attribs = Object.assign(Object.assign({}, attribs), config.elementAttributeTransform({ node }));
    }
    let element = null;
    // more complex transforms
    if (customElementTransforms && customElementTransforms[node.type]) {
        element = customElementTransforms[node.type]({ node, attribs, children });
    }
    else if (config.elementTransforms[node.type]) {
        element = transformElement(config.elementTransforms[node.type]({ node, attribs, children }));
    }
    // straightforward node to element mapping
    if (!element && config.elementMap[node.type]) {
        element = transformElement(new domhandler_1.Element(config.elementMap[node.type], attribs, children));
    }
    // default tag
    if (!element && config.defaultTag && !node.type) {
        element = transformElement(new domhandler_1.Element(config.defaultTag, attribs, children));
    }
    if (element) {
        return element;
    }
    // add line break between inline nodes
    if (config.convertLineBreakToBr && !isLastNodeInDocument) {
        children.push(transformElement(new domhandler_1.Element('br', {})));
    }
    return wrapChildren(children);
};
exports.convertSlate = convertSlate;
